import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import authReducer from '../features/auth/authSlice';
import usersReducer from '../features/users/usersSlice';
import companiesReducer from '../features/companies/companiesSlice';
import aiChatbotsReducer from '../features/ai_chatbots/aiChatbotsSlice';
import settingsReducer from '../features/settings/settingsSlice';
import subscriptionsReducer from '../features/subscriptions/subscriptionsSlice';
import bmsReducer from '../features/bms/bmsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    users: usersReducer,
    companies: companiesReducer,
    aiChatbots: aiChatbotsReducer,
    settings: settingsReducer,
    subscriptions: subscriptionsReducer,
    bms: bmsReducer,
  },
});

// Dispatch ve Selector hook'ları
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;